/*
 * TFS : version servie depuis la copie Avada (deferred-media.aio.min.js) jusqu'au 31/10/2026,
 * reprise telle quelle lors du retrait d'Avada (personnalisation #31, modèle 3D).
 * Ce fichier définit le composant <product-model> autonome (sans DeferredMedia),
 * chargé une seule fois ; product-model.js ajoute les améliorations TFS (accessibilité, zoom, focus).
 * Le code Halothemes d'origine est conservé dans la sauvegarde
 * changes/2026-10-31/theme-1.17-avada-removal/backup/assets/deferred-media.js.
 */
class ProductModel extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
        if (this.getAttribute('loaded')) return;
        this.setAttribute('loaded', true);
        const content = this.querySelector('template')?.content?.cloneNode(true);
        const modelViewer = content?.querySelector('model-viewer');
        if (!modelViewer) return;
        this.appendChild(modelViewer);
        Shopify.loadFeatures([
            {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: this.setupModelViewerUI.bind(this),
            },
        ]);
    }

    setupModelViewerUI(errors) {
        if (errors) return;
        const modelViewer = this.querySelector('model-viewer');
        if (modelViewer) this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
    }
}

customElements.define('product-model', ProductModel);

window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: this.setupShopifyXR.bind(this),
            },
        ]);
    },

    setupShopifyXR(errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
            return;
        }
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
    },
};

window.addEventListener('DOMContentLoaded', () => { window.ProductModel?.loadShopifyXR(); });
